import { render, staticRenderFns } from "./DistributionSlider.vue?vue&type=template&id=2de07c90"
import script from "./DistributionSlider.vue?vue&type=script&lang=js"
export * from "./DistributionSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports